var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head"},[_c('div',{staticClass:"head-title"},[_vm._t("default")],2)]),(_vm.game)?_c('div',{staticClass:"head nopadding"},[_c('div',{staticClass:"head-game",style:({backgroundImage: _vm.gameAvatar})})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }